/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `wooden_pallets` - Wooden Pallets
 * * `no_pallets` - No pallets
 */
export type PackedOnEnum = typeof PackedOnEnum[keyof typeof PackedOnEnum];


export const PackedOnEnum = {
  wooden_pallets: 'wooden_pallets',
  no_pallets: 'no_pallets',
} as const;
